import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Form, Button, Select, message, Radio, Pagination, Card } from "antd";
import useJDStore from "../../store/jd.store";
import "./allEvaluations.scss";
import PlusIcon from "../../assets/plus.png";
import EvaluationDescriptions from "../evaluationDescriptions";
import EvaluationSetup from "../evaluationSetup";
import RTable from "../RTable";
import useQCEStore from "../../store/qce.store";
import { EVALUATIONS_COLUMNS_WIDTH } from "../../helper/tablewidthcontants";

export default function AllEvaluations({ setCurrentView }) {
  const [evalView, setEvalView] = useState("all");
  const [selectedEvID, setEVID] = useState(0);
  const [setCurrentAllJDEvals] = useState();
  const { getJDAllEvals, allJDEvals, allJDEvalsStats, updateFlagQ } =
    useQCEStore();

  const { value } = useParams();

  //when updated
  useEffect(() => {
    if (updateFlagQ) {
      getJDAllEvals(value, setCurrentAllJDEvals);
    }
  }, [updateFlagQ]);

  //init
  useEffect(() => {
    getJDAllEvals(value);
  }, []);

  const getAllEvaluations = () => {
    getJDAllEvals(value, setCurrentAllJDEvals);
    setEvalView("all");
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  useEffect(() => {
    const totalItems = allJDEvals?.length || 0;
    const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [allJDEvals, currentPage]);

  const handlePageChange = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
      console.log("SHOWING the current page", page);
    }
    //rdbResumeSearchPerPage();
  };

  const handlePlusIcon = () => {
    setEvalView("settings");
  };

  const handleSpeceficEVID = (rowidx) => {
    setEVID(allJDEvals?.[rowidx]?.qhevid);
    setEvalView("specific");
  };

  const automationListTable = [
    "Sr. No.",
    "Link Sent",
    "Link Resent",
    "Link Expired",
    "Exam Pending",
    "Exam Ongoing",
    "Exam Timeout",
    "Exam Completed",
    "Exam Not Completed",
    "Proctoring Failed",
    "Other Issues",
    "Exam Cleared",
    "Exam Failed",
  ];

  function showTable(rowIndex) {
    var dataR = getData(rowIndex);
    if (!dataR || dataR.length === 0) {
      return null;
    } else {
      return (
        <RTable
          titleList={automationListTable}
          data={dataR}
          columnWidth={EVALUATIONS_COLUMNS_WIDTH}
        />
      );
    }
  }
  function getData(idx) {
    var sItem = allJDEvalsStats.evalstateperid;
    const evalItemData = sItem?.map((evalItemData, idx) => {
      return {
        id: idx + 1,
        linksent: evalItemData.numsent,
        linkResent: evalItemData.numlinkresent,
        linkExpired: evalItemData.numexpired,
        pending: evalItemData.numpending,
        ongoing: evalItemData.numongoing,
        timeout: evalItemData.numtimeout,
        Complete: evalItemData.numcompleted,
        notComplete: evalItemData.numnotcompleted,
        proctoringfailed: evalItemData.numproctoringfail,
        otherissues: evalItemData.numotherissues,
        cleared: evalItemData.numpass,
        failed: evalItemData.numfail,
      };
    });

    return evalItemData;
  }

  function getEvalName(evid) {
    for (let idx = 0; idx < allJDEvals?.length; idx++) {
      if (allJDEvals?.[idx].qhevid == evid) {
        return (
          allJDEvals?.[idx]?.generalsetting.name +
          "  [" +
          allJDEvals?.[idx]?.qhjdevid +
          "]"
        );
      }
    }
  }

  function getEval(evid) {
    for (let idx = 0; idx < allJDEvals?.length; idx++) {
      if (allJDEvals?.[idx].qhevid == evid) {
        return allJDEvals?.[idx];
      }
    }
  }

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedEvals = allJDEvals?.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="all-evaluations-form-wrapper">
      {evalView === "specific" ? (
        <>
          <div className="evaluations-form-title-wrapper">
            <div className="evaluations-form-title">
              Skill Evalutions - {getEvalName(selectedEvID)}{" "}
            </div>
            <div className="evaluations-form-item">
              <Button onClick={() => setEvalView("all")}>Back</Button>
            </div>
          </div>

          <EvaluationDescriptions
            setView={setEvalView}
            qhjid={value}
            evid={selectedEvID}
            exist={true}
            evalDesc={getEval(selectedEvID)}
          />
        </>
      ) : evalView === "settings" ? (
        <>
          <div className="evaluations-form-title-wrapper">
            <div className="evaluations-form-title">Create New Assement </div>
            <div className="evaluations-form-title-item">
              <Button onClick={() => getAllEvaluations()}>Back</Button>
            </div>
          </div>
          <EvaluationSetup setView={setEvalView} qhjid={value} exist={false} />
        </>
      ) : (
        <>
          <div className="evaluations-form-title-wrapper">
            <div className="evaluations-form-title">
              Current Evalutions (
              {allJDEvals?.length > 0 ? allJDEvals?.length : 0}){" "}
            </div>
          </div>
          <div className="evaluations-form-item-wrapper">
            <div className="evaluations-form-item ">
              <img
                src={PlusIcon}
                alt="Plus"
                width="20"
                height="20"
                className="image"
                onClick={handlePlusIcon}
              />
            </div>
            <div className="evaluations-form-item ">Create New Assessment</div>
          </div>
          <div className="evaluations-form-card-wrapper">
            {allJDEvals?.length > 0
              ? paginatedEvals?.map((evalItem, rowIndex) => {
                  const absoluteIndex = startIndex + rowIndex;

                  return (
                  <div
                    className="evaluations-form-title-item"
                    key={evalItem.qhevid || absoluteIndex}
                  >
                    <Card
                      title={
                        absoluteIndex +
                        1 +
                        ". " +
                        evalItem.generalsetting.name +
                        " [" +
                        evalItem.qhjdevid +
                        "]"
                      }
                      hoverable
                      onClick={() => handleSpeceficEVID(absoluteIndex)}
                      value={absoluteIndex}
                      style={{ width: "70%" }}
                    >
                      {evalItem.state}
                      {showTable(absoluteIndex)}
                    </Card>
                  </div>
                  );
                })
              : "No Evaluations"}
          </div>
          {allJDEvals?.length > itemsPerPage ? (
            <div className="evaluations-form-item" style={{ marginTop: 16 }}>
              <Pagination
                current={currentPage}
                pageSize={itemsPerPage}
                total={allJDEvals.length}
                onChange={handlePageChange}
                showSizeChanger={false}
              />
            </div>
          ) : null}
        </>
      )}
    </div>
  );
}
